export default "/images/vendor/flag-icon-css/flags/4x3/bh.svg?59ba382068ede80f9cb0618c3dfe16f5";